
import highlightsAnimation from '@/mixins/highlights-animation.js'

export default {
  name: 'List',
  mixins: [highlightsAnimation],
  props: {
    unlazyFirstImage: {
      type: Boolean,
      default: false,
    },
    posts: {
      type: Array,
      required: true,
    },
    highlights: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    advertisings: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    postCategories(post) {
      const filtered = post.categories.nodes.filter(
        (category) =>
          // Rimuovo le categorie che non hanno pagine dedicate e nella configurazione sono segnalate in navigation/exclude
          !this.$configuration.navigation.exclude.includes(
            this.$getCategoryRoute(category.slug, 'wpSlug').key
          )
      )
      const categories = filtered.map(
        ({ slug }) => this.$getCategoryRoute(slug, 'wpSlug').key
      )
      return categories
    },
  },
}
